import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useI18n();
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-white/[0.02]">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FF1F87]">
            {t.faq.eyebrow}
          </span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tight">
            {t.faq.title}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {t.faq.items.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="bg-[#0A0A0A] border border-white/10 rounded-2xl px-6 hover:border-[#EC008C]/40 transition-colors"
            >
              <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-white hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-zinc-400 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
